import { HTTP_INTERCEPTORS, HttpClient, HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppComponent } from './app.component';

import { LazyLoadModule } from './lazy-load/lazy-load.module';
// import ngx-translate and the http loader
import { Location, LocationStrategy, PathLocationStrategy } from '@angular/common';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { CubeService } from './services';
import { AzureTokenInterceptor } from './services/interceptors/azure-token.interceptor';
import { MetadataInterceptor } from './services/interceptors/metadata.interceptor';
import { ThemeService } from './services/theme/theme.service';
import * as store from './store';
import { CoreModule } from './core/core.module';

// Load translations from "/assets/i18n/[lang].json"
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}

@NgModule({ declarations: [AppComponent],
    imports: [
        HttpClientModule,
        CoreModule,
        BrowserModule,
        LazyLoadModule,
        // KeycloakAngularModule,
        BrowserAnimationsModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient],
            },
        }),
        StoreModule.forRoot(store.reducers, { metaReducers: store.metaReducers }),
        StoreDevtoolsModule.instrument(store.devtoolsConfig),
            EffectsModule.forRoot(store.effects)
  ],
  exports: [TranslateModule],
  providers: [

        ThemeService,
        Location,
        {
            provide: LocationStrategy,
            useClass: PathLocationStrategy,
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AzureTokenInterceptor,
            multi: true
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: MetadataInterceptor,
            multi: true
        },
        CubeService,
  ],
  bootstrap: [AppComponent],
 })
export class AppModule {}
